












import { Component, Vue } from 'vue-property-decorator'

import config from '@/config'
import Cookie from 'js-cookie'

import CookiePolicy from '@/components/CookiePolicy.vue'

@Component({
	components: {
		CookiePolicy,
	},
})
export default class App extends Vue {
	get showCoockiePolicy() {
		return Boolean(!Cookie.get('cookiePolicyAccepted')) && config.cookiePolicy
	}
}
